import React from "react";
import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";

const CONTAINER = "max-w-6xl mx-auto px-4 sm:px-6 lg:px-8";

export function NearbyTerritories({ nearby, heading = "Nearby Areas We Serve" }) {
  if (!nearby || nearby.length === 0) return null;
  return (
    <section className="py-12 sm:py-16 bg-[#FBF6EC]" data-testid="nearby-territories">
      <div className={CONTAINER}>
        <p className="text-[13px] font-semibold uppercase tracking-[0.14em] text-[#9C1E22]">More local pages</p>
        <h2 className="mt-2 text-2xl sm:text-3xl font-display font-bold text-[#1C4358]">{heading}</h2>
        <div className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {nearby.map((n) => (
            <Link key={n.href} to={n.href} data-testid={`nearby-link-${n.href}`}
              className="group flex items-center justify-between gap-3 rounded-xl bg-white border border-[#1C4358]/10 px-5 py-4 hover:border-[#1C4358]/30 hover:shadow-sm transition-all">
              <span className="flex items-start gap-2.5">
                <MapPin size={17} className="mt-0.5 text-[#9C1E22] shrink-0" />
                <span>
                  <span className="block font-display font-semibold text-[#1C4358] text-[16px]">{n.city}, {n.state}</span>
                  {n.country && <span className="block text-[13px] text-[#7A8A99]">{n.country}</span>}
                </span>
              </span>
              <ArrowRight size={16} className="text-[#1C4358]/50 group-hover:translate-x-1 group-hover:text-[#9C1E22] transition-all shrink-0" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default NearbyTerritories;
